import React from 'react';
import Modal from './Modal';
import { ReactComponent as PassportLogo } from '../svg/passport_logo.svg';

const InformativeModal = ({ visible = false, onClose = () => {} }) => {
    const handleButtonClick = () => {
        window.localStorage.setItem('pass_informative_modal_seen', 'true');
        onClose();
    };

    const handleModalClose = () => {
        onClose();
    };

    return (
        <Modal
            visible={visible}
            label="Welcome to Passport"
            onClose={handleModalClose}
            innerClassName="modal-s text-center"
            showClose={false}
            center
        >
            <div>
                <PassportLogo className="logo" width="250"/>
                <h2>Passport is now part of INaudio</h2>
                <div className="mb-3">
                    <p>
                    Introducing a new chapter for Passport! The Passport service you know and love will continue, and we're excited to add new features in the future to help publishers thrive.
                    </p>
                    <h3>Here’s what this means for you:</h3>
                    <p>
                    We’re currently migrating your existing content to our new system to improve performance and unlock exciting features for you. While this process runs smoothly in the background, it may take a little time before everything appears in your catalog.
                    </p>
                    <p>
                    ✅  You can continue uploading new content as usual — everything you add will be included.
                    <br/>🛠️  Older content is being transferred gradually; if it isn’t showing up yet, don’t worry—it’s on its way!
                     <br/>📬  We’ll send you a follow-up once the migration is complete.
                    </p>
                    <p>
                    Thanks so much for your understanding and support. If you have any questions or notice anything unusual, feel free to reach out — we’re here to help!
                    </p>
                </div>
                <button className="btn btn-sm btn-primary" onClick={handleButtonClick}>
                    Let's start!
                </button>
            </div>
        </Modal>
    );
};

export default InformativeModal; 